export default __webpack_public_path__ + "static/media/Terra.5dd73612.svg";